import { render, staticRenderFns } from "./initiateSupervision.vue?vue&type=template&id=6cd30a83&scoped=true"
import script from "./initiateSupervision.vue?vue&type=script&lang=js"
export * from "./initiateSupervision.vue?vue&type=script&lang=js"
import style0 from "./initiateSupervision.vue?vue&type=style&index=0&id=6cd30a83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd30a83",
  null
  
)

export default component.exports